<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" dark :attrs="attrs" :on="on">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Open Dialog
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Confirm action</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col col="12">
              <h4>
                Please make sure you have collected a payment of
                <strong>{{ yearlyPriceCurrency }} {{ yearlyPrice }}</strong>
                from this business
              </h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12" v-if="activeAccount.enabledDiscountCodes">
              <v-select
                v-model="selectedDiscountCode"
                :items="['', ...activeAccount.enabledDiscountCodes]"
                label="Discount Code"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">
          Close
        </v-btn>
        <v-btn color="blue darken-1" text @click="makeBusinessPremium">
          Update to Premium
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "../../config/config";

export default {
  props: {
    business: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      enteredEmail: "",
      notifications: false,
      sound: true,
      widgets: false,
      rules: [
        (value) => !!value || "Required.",
        (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      ],
      selectedDiscountCode: null,
    };
  },
  computed: {
    ...mapGetters({
      activeAccount: "partner/active",
    }),
    yearlyPrice() {
      return (
        this.business.premiumPricing.p1y.resellerPrice ||
        this.business.premiumPricing.p1y.price
      );
    },
    yearlyPriceCurrency() {
      return this.business.premiumPricing.p1y.currency;
    },
    isWhitelabel() {
      return !!config.whitelabelMode;
    },
  },
  methods: {
    ...mapActions({
      fetchBusinesses: "business/fetchBusinesses",
      updateBusinessToPremium: "business/updateToPremium",
    }),
    async makeBusinessPremium() {
      this.dialog = false;
      try {
        this.$notifier.showMessage({
          content: "Updating..Please wait...",
        });
        await this.updateBusinessToPremium({
          accountId: this.activeAccount.id,
          business: this.business,
          discountCode: this.selectedDiscountCode,
        });
        this.$notifier.showMessage({
          content: "Updated to premium",
        });
        this.fetchBusinesses(this.activeAccount);
      } catch (error) {
        this.$notifier.showMessage({
          content:
            "Update to premium failed. Error: " + error.message || "unknown",
        });
      }
    },
  },
};
</script>
